import { makeStyles } from '@material-ui/core/styles';
import { darkBlue, red, white } from '../../Constants/Colors';
import { bodyFont } from '../../Screens/ThemeProvider';

export const useStyles = makeStyles((theme) => ({
  root: {
    background: darkBlue,
    flex: 1,
    color: white,
  },
  formControl: {
    margin: theme.spacing(1),
    display: 'flex',
    ['& .MuiOutlinedInput-notchedOutline, ' +
    '&:hover .MuiOutlinedInput-notchedOutline, ' +
    '&.Mui-focused .MuiOutlinedInput-notchedOutline']: {
      borderColor: `${red} !important`,
    },
  },
  componentContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  component: {},
  termsContainer: {
    padding: '20px 18px',
    '& .MuiTypography-root': {
      fontSize: '0.98em',
    },
  },
  labelContainer: {
    padding: '16px 14px',
    '& label': {
      display: 'block',
      margin: theme.spacing(1),
      fontSize: '1.2em',
    },
  },
  select: {
    background: white,
    '& .MuiSelect-icon': {
      color: darkBlue,
    },
  },
  textField: {
    borderRadius: '4px',
    '& .MuiInputBase-root': {
      backgroundColor: white,
    },
  },
  textArea: {
    borderColor: red,
    fontSize: '1.2em',
    padding: theme.spacing(1),
    fontFamily: bodyFont,
  },
  checkbox: {
    color: white,
    '& .MuiIconButton-label': {
      color: white,
    },
  },
  formControlLabel: {
    '& .MuiTypography-body1': {
      color: `${white} !important`,
    },
  },
  additionalText: {
    display: 'flex',
    alignItems: 'center',
  },
  divider: {
    width: '98%',
    borderBottom: '1px solid white',
    margin: '24px',
    flexShrink: 1,
  },
  subTitle: {
    marginLeft: '1.5rem',
    marginBottom: '1.5rem',
  },
}));
